import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { MonitoredTrain, TrainTypeConfiguration } from '../../models/monitored-train';
import { MonitoringAlarm } from '../../models/monitoring-alarm';
import { ReferenceArea } from '../../../reference-areas/models/reference-area';
import { environment } from '../../../../../environments/environment';
import {ProjectConfiguration} from '../../../project/models/project-configuration';
import {Incident} from '../../../incidents/models/incident';

@Component({
  selector: 'app-monitored-train-summary',
  template: require('./monitored-train-summary.component.html'),
  styles: [require('./monitored-train-summary.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonitoredTrainSummaryComponent {

  @Input() currentTrain: MonitoredTrain;
  @Input() projectId: number;
  @Input() projectConfiguration: ProjectConfiguration;
  @Input() currentTrainTypeConfiguration: TrainTypeConfiguration;
  @Input() monitoringAlarms: MonitoringAlarm[] | null;
  @Input() referenceAreas: ReferenceArea[];

  @Output() acknowledgeAlarm = new EventEmitter<MonitoringAlarm[]>();
  @Output() investigateAlarm = new EventEmitter<MonitoringAlarm[]>();
  @Output() raiseIncident = new EventEmitter<Incident>();

  selectedHash: string;
  selectedAlarms: MonitoringAlarm[] | null;
  selectedAlarmsTable: MonitoringAlarm[] | null;
  zoom: number = environment.config.map.trainInformation.defaultZoom

  constructor(
  ) { }

  ngOnChanges(): void {
    this.selectedAlarmsTable?.forEach(alarm => {
      const newAlarm = this.monitoringAlarms?.find(currentAlarm => currentAlarm.eventId === alarm.eventId);
      alarm = {
        ...alarm,
        acknowledged:newAlarm? newAlarm.acknowledged: alarm.acknowledged
      }
    });
  }

  onAcknowledgeAlarm = (alarms: MonitoringAlarm[]) => {
    this.acknowledgeAlarm.emit(alarms);
  }

  onInvestigateAlarm = (alarms: MonitoringAlarm[]) => {
    this.investigateAlarm.emit(alarms);
  }

  onRaiseIncident = (incident: Incident) => {
    this.raiseIncident.emit(incident);
  }

  onTreeSelect = (selectedTrainComponents: any[]) => {  
    this.selectedAlarms =  selectedTrainComponents.reduce((acc, item) => {
      if (item.type === 'device') {
        acc = [
          ...acc,
          ...this.monitoringAlarms ? this.monitoringAlarms.filter(alarm => alarm.hostname === item.data.device.hostname) : []
        ];
      }
      return acc;
    }, []);
  }
}
